import React from 'react';
import css from './ProfilePage.module.css';
import { FormattedMessage } from 'react-intl';
import Icons from '../../components/Icons/Icons';
import { H4 } from '../../components';
import { getLabelFromKey, isArrayLength } from '../../util/genericHelpers';
import { professionalFeesConfig } from '../../config/configExtras';

const ProfessionalServicesSection = ({ publicData = {} }) => {
  const { professionalServices = [] } = publicData;

  if (!isArrayLength(professionalServices)) return null;

  return (
    <div className={css.infoBlock}>
      <h2>
        <FormattedMessage id="ProfilePage.professionalServices" />
      </h2>

      <H4 as="h4">
        <FormattedMessage id="ProfilePage.professionalServices.heading" />
      </H4>

      <div className={css.serviceList}>
        {professionalServices.map((key, index) => {
          const label = getLabelFromKey(key, professionalFeesConfig);
          return (
            <div key={index} className={css.service}>
              <Icons name="check" /> {label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProfessionalServicesSection;
